// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import styled from 'styled-components';
import HamCarousel from '../../_common/HamCarousel';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import BackDrop from '../../_common/BackDrop';
import CarouselCard from '../CarouselCard';
import Button from '../../_common/form/Button';

const Wrapper = styled.div`
    display: flex;
    flex-grow: 1;
    justify-content: flex-start;
    flex-direction: column;
    width: 100%;
    height: 100%;
    transition: height 0.2s;
`

const Home = () => {
    const {
        state: {
            site_config
        },
    } = useGlobalState();

    return (
        <Wrapper>
            <BackDrop video src={site_config.homeVideo} />
            <HamCarousel>
                {site_config.carousel.map((e, i) => (
                    <CarouselCard
                        key={`${i}-CarouselCard`}
                        headline={e.headline}
                        text={e.text}
                        button={e.tag ?
                            <Button
                                to={
                                    (site_config.menuItems.find(f => f.tag === e.tag).href) +
                                    (e.href ? `/${site_config.shopItems.find(f => f.tag === e.href)?.href}` : '')
                                }
                            >{e.buttonText}</Button> : null
                        }
                        image={e.image}
                    />
                ))}
            </HamCarousel>
        </Wrapper>
    );
}

export default Home;